/**
 * Lazy session bootstrapping. Most user actions implicitly need a
 * server-side session; the first action creates it on demand.
 *
 * Called from non-React contexts (event handlers), so it talks to
 * the generated request fn directly rather than going through the
 * ``useCreateSession`` hook.
 */

import { createSessionApiSessionsPost } from "@/codegen/openapi/client";
import { useAppStore } from "@/store/app";

export async function ensureSession(): Promise<string> {
  const { sessionId } = useAppStore.getState();
  if (sessionId) return sessionId;
  const r = await createSessionApiSessionsPost();
  if (!r.data) throw new Error(r.error?.toString() ?? "Failed to create session");
  useAppStore.getState().setSessionId(r.data.id);
  return r.data.id;
}
